import { useEffect } from "react";
import { useListAdaptersApiV1AdaptersGet } from "@/api/generated/adapters/adapters";
import { useAppDispatch, useAppSelector } from "@/store";
import { selectProfile } from "@/store/selectors";
import { setAvailableSuppliers } from "@/store/slices/selectedSuppliersSlice";

/**
 * Carica una sola volta i supplier connessi dal BE e popola
 * `selectedSuppliersSlice.available`. Senza questo, il `SupplierPicker`
 * mostra "Nessun supplier configurato" anche quando nel workspace ci sono
 * adapter attivi (RATEHAWK, GOGLOBAL, ecc.).
 *
 * Gated su `profile.activeRole`: `GET /api/v1/adapters` richiede
 * `X-Active-Role`. Mountare la query prima del bootstrap di `/me/profile`
 * causa un 400 una tantum che react-query non rifà (staleTime + retry 0),
 * lasciando l'UI con la lista vuota. Aspettare il bootstrap garantisce
 * che la query parta con il role corretto.
 */
export function useAdaptersBootstrap() {
  const dispatch = useAppDispatch();
  const { activeRole } = useAppSelector(selectProfile);
  const q = useListAdaptersApiV1AdaptersGet({
    query: {
      staleTime: 5 * 60 * 1000,
      retry: 0,
      enabled: Boolean(activeRole),
    },
  });

  useEffect(() => {
    if (!q.data?.connected) return;
    dispatch(
      setAvailableSuppliers(
        q.data.connected.map((s) => ({
          code: s.supplier_code,
          name: s.supplier_name,
        })),
      ),
    );
  }, [q.data, dispatch]);
}
